import React from 'react'

export function TitleBarSubText({
  children,
}: {
  readonly children: React.ReactNode
}) {
  return (
    <p className={'text-subhead text-acorns-slate text-center'}>{children}</p>
  )
}
